export enum BettingMarketsQueryKeys {
  BettingMarkets = "bettingMarkets",
  BettingMarketWithTranslations = "bettingMarkets.withTranslations",
  BettingMarketMappings = "bettingMarkets.mappings",
  BettingMarketsSuspensions = "bettingMarketsSuspensions",
}
